import "./App.css";
import StateApp from "./components/stateapp/stateapp";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter >
      <div className="App">
        <StateApp />
      </div>
    </BrowserRouter>
  );
}

export default App;
